import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import { DataGrid,GridToolbar,GridCellModes  } from '@mui/x-data-grid';
import { Pagination } from "@mui/material";
import Box from '@mui/material/Box';
import { Row, Col, Table,  Form, Modal, Dropdown, } from "react-bootstrap";
import { Link, useNavigate } from 'react-router-dom';
import Card from "../../../../../components/Card";
import CustomToggle from "../../../../../components/dropdowns";
import Button from '@mui/material/Button';
import Select from 'react-select';
import config from "../../../../../config/config";
import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import "../../../../App.css";
import { width } from '@mui/system';
import swal from 'sweetalert';
import { darken, lighten, styled } from '@mui/material/styles';
import {jsPDF} from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import Spinner from 'react-bootstrap/Spinner';
import { data } from 'jquery';

const getBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.7) : lighten(color, 0.7);

const getHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.6) : lighten(color, 0.6);

const getSelectedBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.5) : lighten(color, 0.5);

const getSelectedHoverBackgroundColor = (color, mode) =>
  mode === 'dark' ? darken(color, 0.4) : lighten(color, 0.4);

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  '& .super-app-theme--Open': {
    backgroundColor: getBackgroundColor(theme.palette.info.main, theme.palette.mode),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.info.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.info.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Filled': {
    backgroundColor: getBackgroundColor(
      theme.palette.success.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.success.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.success.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--PartiallyFilled': {
    backgroundColor: getBackgroundColor(
      theme.palette.warning.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.warning.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.warning.main,
          theme.palette.mode,
        ),
      },
    },
  },
  '& .super-app-theme--Rejected': {
    backgroundColor: getBackgroundColor(
      theme.palette.error.main,
      theme.palette.mode,
    ),
    '&:hover': {
      backgroundColor: getHoverBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
    },
    '&.Mui-selected': {
      backgroundColor: getSelectedBackgroundColor(
        theme.palette.error.main,
        theme.palette.mode,
      ),
      '&:hover': {
        backgroundColor: getSelectedHoverBackgroundColor(
          theme.palette.error.main,
          theme.palette.mode,
        ),
      },
    },
  },
}));


const TableData = (props) => {
	console.log('testing page')
	
  const today = new Date();
  const numberOfDaysToAdd = 0;
  const date = today.setDate(today.getDate() + numberOfDaysToAdd); 
  const defaultValue = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
  var Finyear=sessionStorage.getItem("FinYear");
  Finyear=Finyear.substring(0,4);

  const reportOptions = [
    { value: '1', label: 'Dealer Receipt' },
    { value: '2', label: 'Metal Receipt Category' },
  ]


	useEffect(() => {
    setpage(1);
    setuserId(0);
    setacmaster(0);
    getLookup();
 ;

    //  document.getElementById("txtFromDate").value=(new Date()).toISOString().substring(0,10);
    //  document.getElementById("txtTodate").value=(new Date()).toISOString().substring(0,10);

  }, []);

const listPg = (event, value) => {
    setpage(value);
    setuserId(0);
    getLookup();
   
   
  };

  const navigate = useNavigate();



  const [DtUserGroup, setUserGroup]=useState([]);
  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const [GroupId, setGroupId, GroupIdRef] = useStateRef();
  const [reportName, setReportName, ReportNameRef] = useStateRef();
  const [userId, setuserId, userIdRef] = useStateRef('0');
  const [nopage, setnopage, nopageRef] = useStateRef();
  const [page, setpage, pageRef] = useStateRef('1');
  const [acmaster, setacmaster, acmasterRef] = useStateRef('0');
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();
  const [GridData, setGridData] = useState([]);
  const handleClose1 = () => setShow1(false);
  const [isDisabled, setisDisabled]=useState(false);
  const [Search, setSearch, SearchRef] = useStateRef('');
  
  const [ReportTitle,setReportTitle,ReportTitleRef]=useStateRef('');

  const [rowModesModel, setRowModesModel] = React.useState({});
  const [editRowsModel, setEditRowsModel] = React.useState({});
  const [loading, setLoading] = React.useState(false)
  const [btndisabled, setDisabled] = useState('disabled');
  const [newDataRows, setRows] = React.useState([]);
  const [srcURL, setsrcURL] = useState("");
  var dataRows=[];
 
  
  // useEffect(() => {
    
  // }, [newDataRows]);

  async function getLookup(){
    try {
      setGroupId('1');
     let postData=[];
 
 
     const results = await apiService.postCall("metalreceipt/Lookup",postData);
  
    if (results != "-1") {
 
      setUserGroup(results.data[0][0]);

       }
  
     } catch (error) {
       console.log(error);
     }
 }
 const BackToList = () => {
  setDisabled('disabled');
 
};
const addFooters = doc => {
  const pageCount = doc.internal.getNumberOfPages()
  const todayDate = new Date(date).toISOString().split('T')[0] // yyyy-mm-dd
  const printOn=moment(todayDate).format("DD-MM-YYYY");
  doc.setFont('times', 'normal')
  doc.setFontSize(8)
  for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i)
    
      let pageCurrent = doc.internal.getCurrentPageInfo().pageNumber; //Current Page
      doc.text('Page: ' + pageCurrent + ' of ' + pageCount, 200, 10, 'right');
      doc.text('Printed on : ' + printOn, 200, doc.internal.pageSize.height - 10, 'right');
  
  }
}

  
function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}


async function DealerReceipt(dataRows){

  try
  {
     
   
    var pdfDoc = new jsPDF('p','mm',[297,210]);    
    var pdfYpos=10;
    pdfDoc.text("Avathar Jewells", 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
    pdfDoc.setFontSize(10);
    pdfDoc.setFont("Helvetica", "bold");
    var fdate=moment(document.getElementById("txtFromDate").value).format("DD-MM-YYYY");
    var tdate= moment(document.getElementById("txtToDate").value).format("DD-MM-YYYY");
    var RptTitle="Dealer Receipt - From "+fdate +" To "+ tdate;
    pdfDoc.text(RptTitle, 100, pdfYpos, 'center');
    
    pdfYpos=pdfYpos+10;
    var GroupHeadRow=[];
    var GroupFootRow=[];
    var headData = [];
    var tempBody = [];
    var RowId=0;

    var UniqueMetal=[];
    dataRows.map(x => {
      if(UniqueMetal.indexOf(x.MetalType)===-1)
      {
        UniqueMetal.push(x.MetalType)
      }
    });

    headData.push({
     Date: "Date ",
     Dealer: "Dealer",
     GrossWt: "Gross Wt",
     NetWt: "Net Wt",
     Touch: "Touch",
     PureWt: "Pure Wt",
     StMC: "St/MC",
    
   })
   var bodyheightTwo=0;
   var bodyHeight=0;
  

for (var j=0;j<=UniqueMetal.length-1;j++){
  

var data1= dataRows.filter(function (el) {
    return el.MetalType == UniqueMetal[j];
  });
    
  if(data1.length>0)
  {
   
    tempBody.push({
      Date: "",
      Dealer: UniqueMetal[j],
      GrossWt: "",
      NetWt: "",
      Touch: "",
      PureWt: "",
      StMC: "",
      Bold:"",
    })
  
    GroupHeadRow.push(RowId);
    RowId=RowId+1;
    
  }
  

   for (var i=0;i<=data1.length-1;i++){
    
          
                tempBody.push({
                  Date: moment(data1[i].GrnDate).format("DD-MM-YYYY"),
                  Dealer: data1[i].AccDesc,
                  GrossWt: val(data1[i].GrossWt).toFixed(2),
                  NetWt: val(data1[i].NetWT).toFixed(2),
                  Touch: val(data1[i].Touch).toFixed(2),
                  PureWt: val(data1[i].Purewt).toFixed(2),
                  StMC: val(val(data1[i].StoneAmount)+val(data1[i].MCValue)).toFixed(2),
                  Bold:"",
                })
                RowId=RowId+1;
    
  }


  var totalGroup = [...data1.reduce((r, o) => {
    const key = o.MetalType.toString();
  
    const item = r.get(key) || Object.assign({}, o, {
     GrossWt: 0,
     NetWt: 0,
     PureWt: 0,
     StMCAmt: 0
    });
  
    item.GrossWt += o.GrossWt;
    item.NetWt += o.NetWT;
    item.PureWt += o.Purewt;
    item.StMCAmt += val(o.StoneAmount)+val(o.MCValue);
  
    return r.set(key, item);
  }, new Map).values()];
  
  
   
  
  if(totalGroup.length>0){
  tempBody.push({
    Date: "",
    Dealer:"Group Total",
    GrossWt: val(totalGroup[0].GrossWt).toFixed(2),
    NetWt: val(totalGroup[0].NetWt).toFixed(2),
    Touch: "",
    PureWt: val(totalGroup[0].PureWt).toFixed(2),
    StMC: val(totalGroup[0].StMCAmt).toFixed(2),
    Bold:"",
  })
  
  GroupFootRow.push(RowId);
  RowId=RowId+1;
  
  }
  
}


var totalAll = [...dataRows.reduce((r, o) => {
  const key = "";

  const item = r.get(key) ||  Object.assign({}, o, {
   GrossWt: 0,
   NetWt: 0,
   PureWt: 0,
   StMCAmt: 0
  });

  item.GrossWt += o.GrossWt;
  item.NetWt += o.NetWT;
  item.PureWt += o.Purewt;
  item.StMCAmt += val(o.StoneAmount)+val(o.MCValue);

  return r.set(key, item);
}, new Map).values()];


 

if(totalAll.length>0){
tempBody.push({
  Date: "",
  Dealer:"Report Total",
  GrossWt: val(totalAll[0].GrossWt).toFixed(2),
  NetWt: val(totalAll[0].NetWt).toFixed(2),
  Touch: "",
  PureWt: val(totalAll[0].PureWt).toFixed(2),
  StMC: val(totalAll[0].StMCAmt).toFixed(2),
  Bold:"",
})
}

GroupFootRow.push(RowId);




    autoTable(pdfDoc, {
      startY: pdfYpos,
      head: headData,
      body: tempBody,
      tableWidth: 200,
      margin: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
        width: 200
    },
    willDrawCell: function (data) {
      if (data.row.section === 'body') {
          var height = (data.table.body.length + 1) * data.table.body[0].height;
          bodyHeight = height;
      }

      var i=0;
      for( i=0;i<=GroupHeadRow.length-1;i++)
      {
        if (data.row.section === 'body' && data.row.index == GroupHeadRow[i]) {
              //pdfDoc.setFontSize(9);
              pdfDoc.setTextColor(128, 0, 0);
              pdfDoc.setFont("Helvetica", "bold");
        }
      }
     
      for( i=0;i<=GroupFootRow.length-1;i++)
        {
          if (data.row.section === 'body' && data.row.index == GroupFootRow[i]) {
                //pdfDoc.setFontSize(9);
                pdfDoc.setTextColor(128, 0, 0);
                pdfDoc.setFont("Helvetica", "bold");
          }
        }

  },
    styles: {
      overflow: 'linebreak', cellwidth: 'auto'
    },
    headStyles: {
        fontfamily: "Helvetica", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
    },
    theme: "grid",
    bodyStyles: { fontfamily: "Helvetica", fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },

    columnStyles: {
        0: { halign: "left", cellWidth: 25 }, 
        1: { halign: "left", cellWidth: 45 },
        2: { halign: "right", cellWidth: 25 },
        3: { halign: "right", cellWidth: 25 },
        4: { halign: "right", cellWidth: 25 },
        5: { halign: "right", cellWidth: 25 },
        6: { halign: "right", cellWidth: 25 },
        },
    })

    
  if (pdfYpos >= 250) {
        pdfYpos = 20;
        pdfDoc.addPage('p');
    }
    addFooters(pdfDoc);
    setReportTitle(RptTitle);
    setsrcURL(pdfDoc.output('datauristring'));
    setShow1(true);
   
  }

  catch (error) {
    console.log(error);
  }

}
 

async function MetalReceiptCategory(dataRows){

  try
  {
     
   
    var pdfDoc = new jsPDF('p','mm',[297,210]);    
    var pdfYpos=10;
    pdfDoc.text("Avathar Jewells", 100, pdfYpos, 'center');
    pdfYpos=pdfYpos+10;
    pdfDoc.setFontSize(10);
    pdfDoc.setFont("Helvetica", "bold");
    var fdate=moment(document.getElementById("txtFromDate").value).format("DD-MM-YYYY");
    var tdate= moment(document.getElementById("txtToDate").value).format("DD-MM-YYYY");
    var RptTitle="Metal Receipt Category - From "+fdate +" To "+ tdate;
    pdfDoc.text(RptTitle, 100, pdfYpos, 'center');
    

    pdfYpos=pdfYpos+10;
    var GroupHeadRow=[];
    var GroupFootRow=[];
    var headData = [];
    var tempBody = [];
    var RowId=0;
    var TBalanceWt=0;
    var UniqueMetal=[];
    dataRows.map(x => {
      if(UniqueMetal.indexOf(x.LotNo)===-1)
      {
        UniqueMetal.push(x.LotNo)
      }
    });

   
    headData.push({
     Cagegory: "Cagegory ",
     LotNo: "Lot No",
     Date: "Date",
     Weight: "Weight",
     Touch: "Touch",
     PureWt: "Pure Wt",
     BalanceWt: "Balance",
   })
   var bodyheightTwo=0;
   var bodyHeight=0;
  

for (var j=0;j<=UniqueMetal.length-1;j++){
  

var data1= dataRows.filter(function (el) {
    return el.LotNo == UniqueMetal[j] && el.slno==1;
  });
  


  if(data1.length>0)
  {
   
    tempBody.push({

      Cagegory:data1[0].CatName,
      LotNo: data1[0].GrnNo,
      Date: moment(data1[0].SDate).format("DD-MM-YYYY"),
      Weight: val(data1[0].Weight).toFixed(2),
      Touch: val(data1[0].Touch).toFixed(2),
      PureWt: val(data1[0].PureWt).toFixed(2),
      BalanceWt: ""
    })

    TBalanceWt=val(data1[0].balance).toFixed(2);
    
    GroupHeadRow.push(RowId);
    RowId=RowId+1;
    
  }
  

  var data1= dataRows.filter(function (el) {
    return el.LotNo == UniqueMetal[j] && el.slno==2;
  });

  var TWeight=0;
  var TPureWt=0;
  
   for (var i=0;i<=data1.length-1;i++){
                tempBody.push({
                  Cagegory:data1[i].CatName,
                  LotNo: data1[i].GrnNo,
                  Date: moment(data1[i].SDate).format("DD-MM-YYYY"),
                  Weight: val(data1[i].Weight).toFixed(2),
                  Touch: val(data1[i].Touch).toFixed(2),
                  PureWt: val(data1[i].PureWt).toFixed(2),
                  BalanceWt: ""
                })

                TWeight=val(val(TWeight)+val(data1[i].Weight)).toFixed(2);
                TPureWt=val(val(TPureWt)+val(data1[i].PureWt)).toFixed(2);
                TBalanceWt=val(data1[i].balance).toFixed(2);

            
                RowId=RowId+1;
  }



  
  
  tempBody.push({
    Cagegory:"",
    LotNo: "",
    Date: "Total",
    Weight: val(TWeight).toFixed(2),
    Touch: "",
    PureWt: val(TPureWt).toFixed(2),
    BalanceWt: val(TBalanceWt).toFixed(2)
  })
  
  GroupFootRow.push(RowId);
  RowId=RowId+1;
  
  
  
}

  
    autoTable(pdfDoc, {
      startY: pdfYpos,
      head: headData,
      body: tempBody,
      tableWidth: 200,
      margin: {
        top: 20,
        bottom: 20,
        left: 10,
        right: 10,
        width: 200
    },
    willDrawCell: function (data) {
      if (data.row.section === 'body') {
          var height = (data.table.body.length + 1) * data.table.body[0].height;
          bodyHeight = height;
      }

      var i=0;
      for( i=0;i<=GroupHeadRow.length-1;i++)
      {
        if (data.row.section === 'body' && data.row.index == GroupHeadRow[i]) {
              //pdfDoc.setFontSize(9);
              pdfDoc.setTextColor(128, 0, 0);
              pdfDoc.setFont("Helvetica", "bold");   
        }
      }
     
      for( i=0;i<=GroupFootRow.length-1;i++)
        {
          if (data.row.section === 'body' && data.row.index == GroupFootRow[i]) {
                //pdfDoc.setFontSize(9);
                pdfDoc.setTextColor(128, 0, 0);
                pdfDoc.setFont("Helvetica", "bold");
          }
        }

  },
    styles: {
      overflow: 'linebreak', cellwidth: 'auto'
    },
    headStyles: {
        fontfamily: "Helvetica", fontStyle: 'bold', fontSize: 8.5, lineWidth: 0.5, fillColor: "#ffffff", lineColor: [0, 0, 0], textColor: [0, 0, 0], halign: 'center'
    },
    theme: "grid",
    bodyStyles: { fontfamily: "Helvetica", fontStyle: 'normal', fontSize: 8.5, textColor: [0, 0, 0],lineColor: [0, 0, 0] },
 
    columnStyles: {
        0: { halign: "left", cellWidth: 40 }, 
        1: { halign: "left", cellWidth: 25 },
        2: { halign: "right", cellWidth: 25 },
        3: { halign: "right", cellWidth: 25 },
        4: { halign: "right", cellWidth: 25 },
        5: { halign: "right", cellWidth: 25 },
        6: { halign: "right", cellWidth: 25 },
        },
    })
  
        
  if (pdfYpos >= 250) {
        pdfYpos = 20;
        pdfDoc.addPage('p');
    }
    addFooters(pdfDoc);
    setReportTitle(RptTitle);
    setsrcURL(pdfDoc.output('datauristring'));
    setShow1(true);
   
  }

  catch (error) {
    console.log(error);
  }

}
async function GenereatePdf(){
  dataRows=[];
  let reportName=String(ReportNameRef.current)
  var results;

  setReportTitle('');

  setLoading(true);
  
  if (reportName=="Dealer Receipt"){
    let postData = {
      "fromDate" :document.getElementById("txtFromDate").value,
      "toDate" : document.getElementById("txtToDate").value,
      "finyear" : Finyear
    }
    results = await apiService.postCall("smithreport/dealerreceipt",postData);
    if (results != "-1") {
      setLoading(false);
      setGridData(results.data.Head[0]);
      dataRows=results.data.Head[0];
      settotalCount(results.totalCount);
      setcurrentpg(postData.PageNumber);
      DealerReceipt(dataRows);
    }
  }
else   if (reportName=="Metal Receipt Category"){
  let postData = {
    "fromDate" :document.getElementById("txtFromDate").value,
    "toDate" : document.getElementById("txtToDate").value,
    "finyear" : Finyear
  }
  results = await apiService.postCall("smithreport/metalreceiptcategory",postData);
  if (results != "-1") {
    setLoading(false);
    setGridData(results.data.Head[0]);
    dataRows=results.data.Head[0];
    settotalCount(results.totalCount);
    setcurrentpg(postData.PageNumber);
    MetalReceiptCategory(dataRows);
  }
}  
  
 
}
  return (
    <>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
                      
              <div className="header-title">
                <h4 className="card-title">Reports Others</h4>
              </div>
             
               <Modal  size="lg" className=".modal-xl" id="ReportModal"
            aria-labelledby="contained-modal-title-vcenter"
             centered show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho}  </Modal.Title>{ReportTitle}
                   
                  </Modal.Header>
                  <Modal.Body>
                  <iframe  id="docpdf"  src={srcURL} 
                         height="500"
                         width="100%"
                         allowFullScreen={true}/>

                  </Modal.Body>
                </Modal> 


            </Card.Header>

            <Card.Body>

                        
            <div className='container-fluid py-4 '>
                    <div className='row py-2'> 

                       <div className='col-md-4'>
                            <Form.Label>From Date</Form.Label>
                            <Form.Control type="date" id="txtFromDate" placeholder="" defaultValue={defaultValue} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>To Date</Form.Label>
                            <Form.Control type="date"  id="txtToDate" placeholder="" defaultValue={defaultValue} />
                          </div>

                         
                        
                        </div>
                        <div className='row py-1'>
                        <div className='col-md-6'>
                        <Form.Label>Report Name</Form.Label>
                          <Select options={reportOptions} id="txtReportName"  onChange=
                            {
                              (e) => {
                              setReportName(e.label);
                              }
                              }/>
                        </div>
                        <div className='col-md-6' style={{marginTop : 35}}>
                         
                         {/* <Button type="button" variant="contained" onClick={SaveFunc}>View</Button> &nbsp;&nbsp;&nbsp; */}
                         <Button type="button"  variant="contained" onClick={GenereatePdf}>Print</Button>
                     
                         
                         </div>


                        </div>
                      </div>

                        <div className='pt-1' style={{ direction: 'rtl' }} >
                       
                        <Form.Group className="form-group">
                  
                 
               
                  
                </Form.Group>
             

              </div>

        <Box sx={{ height: 400, width: 1000,
               '.MuiDataGrid-columnHeaderTitle': { 
                fontWeight: 'bold !important',
                overflow: 'visible !important'
             },
             '& .super-app-theme--cell': {
              backgroundColor: 'rgba(157, 255, 118, 0.49)',
              color: '#1a3e72',
              fontWeight: '600',
            },
            '& .super-app.positive': {
              backgroundColor: '#d47483',
              color: '#1a3e72',
              fontWeight: '600',
            },
              }}>
                  {/* <StyledDataGrid
                   //checkboxSelection
                   editMode="row"
                    rows={GridData}
                    columns={columns}
                    getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                    getRowId={(row) =>  row.AccCode}
                     showCellVerticalBorder 
                     showColumnVerticalBorder 
                     loading={loading}
                    slots={{ toolbar: GridToolbar }}
                   
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 10
                        }
                      }
                    }}

                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      
                      },
                    }}
                  /> */}

                
      <div className="container rsvp-wrapper">
                    {loading ?  (
        <Button   variant="primary" disabled style={{justifyContent: "center",alignItems:"center"}}>
        <Spinner style={{ height: 50, width: 50}}  className="loading text-center"
            name="three-bounce"
            color="white"
            fadeIn="none"
            /> Loading... </Button>) : null  }<iframe hidden="true" id="docpdf"  src={srcURL} 
                         height="500"
                         width="1000"
                         onLoad={() => setLoading(false)}
                         allowFullScreen={true}
                         
                         />
                 </div>
                </Box>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TableData;
